export const CART_PAGE_SECTION = 'Cart';
export const CART_PAGE_STAGE = 'Checkout';
export const CART_PAGE_NAME = 'Checkout:Cart';
